import React, { useCallback, useEffect, useRef } from "react"
import { FaDeleteLeft } from "react-icons/fa6"

import classes from "./CheckoutKeypad.module.scss"
import clsx from "clsx"

const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "پاک", "0", "del"]

const CheckoutKeypad = props => {
  const {
    value,
    isLinkPay,
    disabled,
    onChange,
    focusedCashType
  } = props

  const firstInput = useRef(true)

  const handlePress = (key) => {
    if (isLinkPay) return

    if (key === "پاک") return onChange("0")

    if (firstInput.current) {
      firstInput.current = false

      return onChange(key === "del" ? "0" : key)
    }

    const string =
      String(value) === "0" ? "" : String(value)

    if (value === "0" && key === "0") {
      return onChange(String(value))
    }

    if (key === "del") {
      return onChange(
        string.length === 1 || string.length === 0 ? 0 :
          string.substring(0, string.length - 1)
      )
    }

    onChange(string + key)
  }

  const handleKeyPress =
    useCallback((e) => {
      let key = ""

      if (!isNaN(e.key)) {
        key = e.key
      }

      if (e.key === "Backspace") {
        key = "del"
      }

      if (e.key === "Delete") {
        key = "پاک"
      }

      if (key === "") return

      handlePress(key)
    }, [focusedCashType, value])

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress)

    return () => {
      window.removeEventListener("keydown", handleKeyPress)
    }
  }, [focusedCashType, value])

  useEffect(() => {
    firstInput.current = true
  }, [focusedCashType])

  return (
    <div
      id="checkout-keypad"
      className={classes["container"]}
    >
      <div className={classes["wrapper"]}>
        {keys.map(key =>
          <button
            key={key}
            disabled={disabled}
            className={clsx(
              classes["key"],
              disabled && classes["disabled"]
            )}
            onClick={() => handlePress(key)}
          >
            {key === "del" ? <FaDeleteLeft size={20} /> : key}
          </button>
        )}
      </div>
    </div>
  )
}

export default React.memo(CheckoutKeypad)